import { render, staticRenderFns } from "./Disciplines.vue?vue&type=template&id=e4fca932"
import script from "./Disciplines.vue?vue&type=script&lang=js"
export * from "./Disciplines.vue?vue&type=script&lang=js"
import style0 from "./Disciplines.vue?vue&type=style&index=0&id=e4fca932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports